import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import { Route, Switch } from 'react-router-dom';
//import ClassesPage from './classManager/ClassesPage';
import PageNotFound from './PageNotFound';
import UserPage from './userPage/MainPage';
import Header from './common/Header';
import Footer from './common/Footer';
import SubscriptionPage from './subscriptionPage/MainPage';
import ProfilePage from './profilePage/MainPage';
import DatabasePage from './databasePage/MainPage';
import AssignmentsPage from './assignmentsPage/MainPage';
import ReportsPage from './reportsPage/MainPage';
import ViewReportsPage from './reportsPage/ViewReportsPage';
import SummaryPage from './summaryPage/MainPage';
import LoginPage from './loginPage/MainPage';

import IdleTimer from '../IdleTimer';

class App extends Component {

  constructor(props) {
    super(props);

    console.log('App:'+localStorage.getItem('_expiredTime'));
    let timeout = 60*25; // expires in 25 minutes
    localStorage.setItem('_expiredTime', (Date.now() + timeout * 1000)+'');
    console.log('new ExpireTime:'+localStorage.getItem('_expiredTime'));

    const timer = new IdleTimer({
      timeout,
      renewTokenTime: 60*10,
      onTimeout: () => {
        timer.cleanUp();
        // console.log('onTimeout');
      },
      onExpired: () => {
        //do something if expired on load
        console.log('onExpired');
      }
    });

    // return () => {
    //   timer.cleanUp();
    // };
  }

  render() {
    return (
      <>
      <Header/>
      <Container>
          <Switch>
            <Route exact path="/" component={LoginPage} />
            <Route exact path="/summary" component={SummaryPage} />

            {/* <Route path="/students" component={StudentPage} /> */}
            <Route path="/users" component={UserPage} /> 
            <Route path="/databases" component={DatabasePage} />
            <Route path="/subscriptions" component={SubscriptionPage} />
            <Route path="/profile" component={ProfilePage} />

            <Route path="/reports" component={ReportsPage} />
            <Route path="/viewreports" component={ViewReportsPage} />
            <Route path="/assignments" component={AssignmentsPage} />

            {/* <Route path="/teacherProfile" component={TeacherProfilePage} /> */}
            {/* <Route path="/student/:slug" component={ManagestudentPage} /> */}
            <Route component={PageNotFound} />
          </Switch>
      </Container>
      <Footer/>
      </>
    );
  }
}

export default App;
